import { useEffect, useState } from "react";
import axios, { apiBaseUrl } from "../../api/axios";
import Select from "react-select";
import Flatpickr from "react-flatpickr";
import Modal from "../../components/Modal";
import ResponsiveTable from "../../components/ResponsiveTable";
import { EyeIcon, PencilIcon, TrashIcon, CurrencyDollarIcon, DocumentCheckIcon, MoonIcon, BuildingLibraryIcon } from "@heroicons/react/24/outline";
import ExportButtons from "../../components/ExportButtons";
import { useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";
import moment from "moment"
import { toast } from 'react-toastify';
import Loader from '../../components/Loader';

export default function PurchasesList() {
    const navigate = useNavigate();
    const [supplierOption, setSupplierOption] = useState([]);
    const [loading, setLoading] = useState(false);
    const [filtered, setFiltered] = useState([]);
    const [purchasesCount, setPurchasesCount] = useState([]);
    const [paymentList, setPaymentList] = useState([]);
    const [filters, setFilters] = useState({
        status: null,
        payment_status: null,
        item: "",
        supplier: null,
        start: moment().subtract(30, "days").startOf('day').format("YYYY-MM-DD"),
        end: moment().add(1, "days").format("YYYY-MM-DD"),
    });
    const [isModalOpen, setIsModalOpen] = useState(false);
    const closeModal = () => setIsModalOpen(false);
    const getSalesData = () => {
        setLoading(true)
        axios.get("/purchases", {
            params: {
                start_date: filters.start,
                end_date: filters.end,
                payment_status: filters.payment_status,
                status: filters.status,
                supplier_id: filters.supplier
            }
        }).then((res) => {
            setLoading(false)
            setFiltered(res.data);
        }).catch(err => {
            setLoading(false)
            toast.error(err.message || `Error`)
        });
    }
    const getPaymentList = (purchasesId) => {
        axios.get(`/purchases/${purchasesId}/payments`)
            .then(res => {
                console.log('Payment History:', res.data);
                setPaymentList(res.data)
            })
            .catch(err => console.error(err));
    }
    const getPurchasesCount = () => {
        axios.get(`/purchases/count`)
            .then(res => {
                setPurchasesCount(res.data)
            })
            .catch(err => console.error(err));
    }
    useEffect(() => {
        getSalesData()
        getPurchasesCount()
        axios.get('/suppliers').then(res => {
            const customerOption = res.data?.map((item) => {
                return { value: item.id, label: item.name };
            });
            setSupplierOption([{ value: null, label: "All Suppliers" }, ...customerOption])
        });
    }, []);
    const statCards = [
        {
            title: 'Total Purchases',
            icon: <CurrencyDollarIcon className="text-2xl" />,
            value: purchasesCount.total_purchases_amount || 0
        },
        {
            title: 'Total paid',
            icon: <MoonIcon className="text-green-500 text-2xl" />,
            value: purchasesCount.total_paid || 0
        },
        {
            title: 'Total Due',
            icon: <BuildingLibraryIcon className="text-yellow-500 text-2xl" />,
            value: purchasesCount.total_due || 0
        },
        {
            title: 'Total Invoice',
            icon: <DocumentCheckIcon className="text-blue-500 text-2xl" />,
            value: purchasesCount.total_invoices || 0
        },
    ];
    useEffect(() => {
        getSalesData()
    }, [filters]);

    const capitalizeFirstLetter = (word) => {
        if (!word || typeof word !== "string") return word;
        return word.charAt(0).toUpperCase() + word.slice(1);
    };
    const handleExportPDF = () => {
        const pdfContent = filtered.map(s => ({
            ID: s.id,
            Customer: s.customer_name,
            Items: s.items?.map(i => i.name).join(", "),
            Total: s.total,
            Date: s.sale_date,
            Status: s.status,
            Payment: s.payment_status
        }));
        import('jspdf').then(jsPDF => {
            import('jspdf-autotable').then(() => {
                const doc = new jsPDF.jsPDF();
                doc.autoTable({ head: [Object.keys(pdfContent[0]).filter(h => h !== 'actions')], body: pdfContent.map(obj => Object.entries(obj).filter(([k]) => k !== 'actions').map(([, v]) => v)) });

                const date = new Date().toISOString().slice(0, 10);
                const logo = new Image();
                logo.src = "/logo-dark.png";
                logo.onload = () => {
                    doc.addImage(logo, "PNG", 10, 10, 30, 10);
                    doc.setFontSize(14);
                    doc.text("Sales Report", 50, 17);
                    doc.autoTable({
                        startY: 25,
                        head: [Object.keys(pdfContent[0]).filter(h => h !== 'actions')],
                        body: pdfContent.map(obj => Object.entries(obj).filter(([k]) => k !== 'actions').map(([, v]) => v))
                    });
                    doc.save(`Sales_Report_${date}.pdf`);
                };

            });
        });
    }
    const salesOptions = [
        { value: null, label: "All Status" },
        { value: "Received", label: "Received" },
        { value: "Pending", label: "Pending" },
        { value: "Ordered", label: "Ordered" },
    ];
    const paymentOptions = [
        { value: null, label: "All Payment" },
        { value: "paid", label: "Paid" },
        { value: "unpaid", label: "Unpaid" },
    ];
    const handleExport = () => {

        const ws = XLSX.utils.json_to_sheet(filtered);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Sales");
        XLSX.writeFile(wb, "Sales_List.xlsx");
    };

    const actions = [
        { label: 'View', value: 'view', icon: <EyeIcon className="w-4 h-4 inline" /> },
        { divider: true },
        { label: 'Edit', value: 'edit', icon: <PencilIcon className="w-4 h-4 inline" /> },
        { divider: true },
        { label: 'View Payments', value: 'payment', icon: <CurrencyDollarIcon className="w-4 h-4 inline" /> },
        { divider: true },
        { label: 'Delete', value: 'delete', icon: <TrashIcon className="w-4 h-4 inline text-red-600" /> },
    ];
    const handleActionClick = (action, row) => {
        switch (action) {
            case "view":
                navigate(`/purchases/view/${row.id}`);
                break;
            case "edit":
                navigate(`/purchases/edit/${row.id}`);
                break;
            case "payment":
                getPaymentList(row.id)
                setIsModalOpen(true)
                break;
            case "delete":
                if (window.confirm("Are you sure you want to delete this sale?")) {
                    axios.delete(`/items/${row.id}`).then(() => {
                        setItems(prev => prev.filter(s => s.id !== row.id));
                    });
                }
                break;
            default:
                break;
        }
    };
    const handleDownload = (type) => {
        const url = `${apiBaseUrl}/purchases/export/${type}`;
        window.open(url, "_blank");
    };
    const columns = [
        { header: "SL", accessor: "sl", render: (v, row, i) => i + 1 },
        {
            header: "Date", accessor: "purchase_date",
            render: (value, row) => <span>{moment(value).format("DD/MM/YYYY")}</span>
        },
        { header: "Customer", accessor: "supplier_name" },
        { header: "Ref No.", accessor: "reference" },
        {
            header: "Paid Amt", accessor: "paid_amount",
            render: (value, row) => <span className="text-green-700">{value} BDT</span>
        },
        {
            header: "Due Amt", accessor: "due_amount",
            render: (value, row) => <span className="text-red-500">{value} BDT</span>
        },
        {
            header: "Total Amt", accessor: "total",
            render: (value, row) => <span className="font-semibold">{value} BDT</span>
        },
        {
            header: "P. Status", accessor: "status",
            render: (value, row) => <span className={`${value === "Received" ? " text-green-600 font-semibold" : "text-red-500 font-semibold"}`}>{capitalizeFirstLetter(value)}</span>
        },
        {
            header: "P. Status", accessor: "payment_status",
            render: (value, row) => <span className={`${value === "partial" ? " text-blue-700 font-semibold" : value === "unpaid" ? "text-red-500 font-semibold" : "text-green-500 font-semibold"}`}>{capitalizeFirstLetter(value)}</span>
        },
        { header: "Created by", accessor: "user_name" },
    ];

    return (
        <div className=" relative p-4 max-w-6xl mx-auto text-sm bg-white rounded-md">
            {/* <div className="flex flex-wrap gap-2">
        <button onClick={handleExportPDF} className="px-3 py-1 border rounded bg-red-500 text-white">Export PDF</button>
        <button onClick={handleExport} className="px-3 py-1 border rounded bg-blue-500 text-white">Export Excel</button>
      </div> */}
            <div className="w-full">
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-4 gap-4 mb-4 max-sm:mb-2">
                    {statCards.map((card, index) => (
                        <div
                            key={index}
                            className="rounded-2xl bg-white shadow-md p-4 flex items-center gap-4 border border-gray-200"
                        >
                            <div className="bg-gray-100 w-16 p-3 rounded-full">
                                {card.icon}
                            </div>
                            <div>
                                <p className="text-sm font-bold text-gray-500">{card.title}</p>
                                <p className="text-xl font-bold">{card.value}</p>
                            </div>
                        </div>
                    ))}
                </div>
                <ExportButtons title="Purchases List" onDownload={handleDownload} />
                <div className="grid grid-cols-1 md:grid-cols-5 gap-4 mb-4">
                    <div className="flex items-center rounded-md">
                        <Flatpickr
                            style={{
                                backgroundColor: "#fff",
                                opacity: "1",
                                padding: "9px 12px",
                            }}
                            // options={{
                            //   dateFormat: "d-m-Y"
                            // }}
                            value={filters.start}
                            id="date-time-picker"
                            className="form-control"
                            onChange={(date) => setFilters(f => ({ ...f, start: date[0] }))}
                        />
                    </div>
                    <div className="flex items-center rounded-md">
                        <Flatpickr
                            style={{
                                backgroundColor: "#fff",
                                opacity: "1",
                                padding: "9px 12px",
                            }}
                            // options={{
                            //   dateFormat: "d-m-Y",
                            // }}
                            value={filters.end}
                            id="date-time-picker"
                            className="form-control"
                            onChange={(date) => setFilters(f => ({ ...f, end: date[0] }))}
                        />
                    </div>
                    <div className="flex items-center rounded-md">
                        <Select
                            name="Supplier"
                            onChange={e => setFilters(f => ({ ...f, customer: e.value }))}
                            options={supplierOption}
                            placeholder="Select Supplier"
                            className="w-full"
                            classNamePrefix="react-select"
                            maxMenuHeight={150}
                        />
                    </div>
                    <div className="flex items-center rounded-md">
                        <Select
                            name="status"
                            onChange={e => setFilters(f => ({ ...f, status: e.value }))}
                            options={salesOptions}
                            placeholder="Select Status"
                            className="w-full"
                            classNamePrefix="react-select"
                            maxMenuHeight={150}
                        />
                    </div>
                    <div className="flex items-center rounded-md">
                        <Select
                            name="payment"
                            onChange={e => setFilters(f => ({ ...f, payment_status: e.value }))}
                            options={paymentOptions}
                            placeholder="Select Payment"
                            className="w-full"
                            classNamePrefix="react-select"
                            maxMenuHeight={150}
                        />
                    </div>
                </div>
                <ResponsiveTable
                    columns={columns}
                    data={filtered}
                    showActions
                    actionButtons={actions}
                    onActionClick={handleActionClick}
                />
            </div>
            {/* Modal */}
            <Modal
                isOpen={isModalOpen}
                onClose={closeModal}
                header={<span className="text-blue-600">Payment History</span>}
                body={
                    <div className="mb-3">
                        <table className="w-full my-2 border text-xs">
                            <thead className="bg-blue-800 text-white">
                                <tr>
                                    <th className="border px-2 py-1">#</th>
                                    <th className="border px-2 py-1">Date</th>
                                    <th className="border px-2 py-1">Bank Name</th>
                                    <th className="border px-2 py-1">Amount</th>
                                    <th className="border px-2 py-1">Type</th>
                                </tr>
                            </thead>
                            {paymentList.length > 0 ? paymentList.map((item, i) => (
                                <tr className='odd:bg-white even:bg-gray-100' key={i}>
                                    <td className="border px-2 py-1 font-medium">{i + 1}</td>
                                    <td className="border px-2 py-1 text-center">{moment(item.created_at).format("DD-MM-YYYY hh:mm:ss A")}</td>
                                    <td className="border px-2 py-1 text-center">{item.bank_name}</td>
                                    <td className="border px-2 py-1 text-center">{Number(item.amount).toFixed(2)}</td>
                                    <td className="border px-2 py-1 text-center">{capitalizeFirstLetter(item.type)}</td>
                                </tr>
                            )) : <tr className="mb-2">
                                <td colSpan={5} className="text-center py-2">No payment found</td>
                            </tr>}
                        </table>
                    </div>
                }
                footer={
                    <div className="flex gap-2">
                        <button
                            onClick={closeModal}
                            className="px-4 py-2 text-gray-700 bg-gray-200 rounded hover:bg-gray-300"
                        >
                            Close
                        </button>
                    </div>
                }
            />
            <Loader show={loading} />
        </div>
    );
}